import React, { useEffect, useState } from 'react';
import { PreviewFile } from './MediaViewer';
import { PDFObject } from 'react-pdfobject';
import Loading from '../../BaseModule/Components/Loading';

interface MediaViewerDisplayPdfProps {
	file: PreviewFile;
}

export default function MediaViewerDisplayPdf(
	props: MediaViewerDisplayPdfProps,
) {
	const { file } = props;
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			setIsLoading(false);
		}, 0);
	}, []);

	if (isLoading) {
		return <Loading />
	}

	return (
		<div
			id='native-pdf-wrapper'
			className='embed-responsive embed-responsive-4by3'
			style={{ marginTop: '20px', maxHeight: '100%' }}
		>
			<PDFObject url={file.download} containerId={'native-pdf-wrapper'}/>
		</div>
	);
}
